module.exports = __webpack_public_path__ + "static/media/sa.bc21587e.jpeg";